import { Author, Caption, LayoutConfig, PageConfig, TextConfig, UserConfig } from './src/config/models';

// Texte für Title, SEO & Sharing, ...
const de: TextConfig = {
    title: 'So bringen Biometrie-Geräte Afghanen in Gefahr',
    headerInfo: 'Ein Soldat der US-Marines scannt die Augen einer Person in Afghanistan.',
    headerCredits: 'Bildrechte: US-Marines/gemeinfrei, Bearbeitung: BR/Steffen Kühne',
    interactiveNote: 'Vereinfachte Darstellung, Namen und Details geändert',
    headline:
        'Eine BR-Recherche zeigt: Menschen in Afghanistan sind in Lebensgefahr, weil westliche Streitkräfte biometrische Daten nicht vor den Taliban geschützt haben. Ihnen könnten Biometrie-Scanner zum Verhängnis werden, die Nato-Truppen im Land zurückgelassen haben.',
    description:
        'US-Truppen und ihre Verbündeten haben in Afghanistan Millionen von Menschen biometrisch erfasst - mit tausenden Biometrie-Geräten. Nach dem chaotischen Abzug der internationalen Truppen im August 2021 blieben offenbar viele Geräte zurück. Expertinnen und Experten befürchten, dass die Taliban diese einsetzen könnten, um Menschen zu identifizieren, an denen sie sich rächen wollen. Ob das tatsächlich möglich ist, war nicht belegt. Bis jetzt.',
    keywords: ['Biometrie', 'Afghanistan', 'biometrische Daten', 'Gefahr'],
    mobileShareText:
        'Sie sind klein und unscheinbar - trotzdem könnten Biometrie-Geräte, die Nato-Truppen in Afghanistan zurückgelassen haben, Menschen in Lebensgefahr bringen. So konkret ist die Gefahr.',
    twitterShareText:
        'Sie sind klein und unscheinbar - trotzdem könnten Biometrie-Geräte, die Nato-Truppen in Afghanistan zurückgelassen haben, Menschen in Lebensgefahr bringen. So konkret ist die Gefahr.',
    whatsappShareText:
        'Sie sind klein und unscheinbar - trotzdem könnten Biometrie-Geräte, die Nato-Truppen in Afghanistan zurückgelassen haben, Menschen in Lebensgefahr bringen. So konkret ist die Gefahr.',
    mailShareText:
        'Sie sind klein und unscheinbar - trotzdem könnten Biometrie-Geräte, die Nato-Truppen in Afghanistan zurückgelassen haben, Menschen in Lebensgefahr bringen. So konkret ist die Gefahr.'
};

// Falls englische Seite gewünscht ("provideEn" in pageConfig = true), Übersetzungen hier eintragen:
const en: TextConfig = {
    title: 'How Biometric Devices Are Putting Afghans in Danger',
    headerInfo: 'US Marine scanning biometric data in Afghanistan',
    headerCredits: 'Credits: US Marines/public domain',
    interactiveNote: 'Simplified presentation, names and details were changed',
    headline:
        'Reporting by Bayerischer Rundfunk has found that the lives of people in Afghanistan are in danger because Western militaries failed to protect biometric data from the Taliban. Their fates could be sealed due to biometric scanners that NATO troops left behind in the country.',
    description:
        'U.S. troops and their allies collected the biometric data of millions of people in Afghanistan using thousands of biometric scanners. During the chaotic withdrawal of the international troops in August 2021, many of those devices were apparently left behind. Experts have long feared that the Taliban could potentially use those devices to identify people on whom they wish to take revenge. But it had never been proven that such a thing was actually possible. Until now.',
    keywords: ['Biometrics', 'Biometric Devices', 'Afghanistan', 'biometric data', 'danger'],
    mobileShareText: 'How Biometric Devices Are Putting Afghans in Danger',
    twitterShareText: 'How Biometric Devices Are Putting Afghans in Danger',
    whatsappShareText: 'How Biometric Devices Are Putting Afghans in Danger',
    mailShareText: 'How Biometric Devices Are Putting Afghans in Danger'
};

// Konfiguration der Seiteninhalte
const pageConfig: Omit<PageConfig, 'url'> = {
    provideEn: true,
    authors: [Author.RebeccaCiesielski, Author.MaximilianZierer],
    caption: Caption.Nachrichten,
    ATId: 'biometrie-longread',
    previewImage: 'media/preview.jpg',
    headerImage: 'media/preview.jpg'
};

// Basic Layout Konfiguration (eher Entwickler-Einstellungen)
const layoutConfig: LayoutConfig = {
    // Whether to show information on the side within the header image
    showAside: false,
    // Whether to show the reading/scroll progress in navbar or not
    showProgress: true,
    // Display the title in the header image and not in the text underneath
    titleInHeader: false,
    // Pushes up the text content slightly into the header picture
    headerOverlay: true
};

// Hier nichts verändern
export const config: UserConfig = {
    ...pageConfig,
    ...layoutConfig,
    de,
    en
};
